import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { UptimesOverviewComponent } from './uptimes.component';
import { UptimeShowComponent } from './uptime-show/uptime-show.component';
import { IncidentListComponent } from './uptime-show/incident-list/incident-list.component';
import { ComponentsModule } from '@client/app/components/components.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { ExportModule } from '@client/app/modules/export/export.module';
import { UIRouterModule } from '@uirouter/angular';
import { LayoutModule, MonDatePickerModule, MonEventTriggerModule } from '@monsido/angular-shared-components';
import { LineComponent } from '@client/app/modules/charts/components/line.component';
import { CommonModule } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { MomentsModule } from '@client/app/modules/moments/moments.module';
import { MonActionMenuModule } from '@client/ng2/shared/components/action-menu/action-menu.module';
import { DatePickerComponent } from '@client/app/components/date-picker/date-picker.component';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        ComponentsModule,
        TranslateModule,
        ExportModule,
        UIRouterModule,
        MonEventTriggerModule,
        MonDatePickerModule,
        LayoutModule,
        LineComponent,
        NgbTooltip,
        UpgradePipeModule,
        MomentsModule,
        MonActionMenuModule,
        DatePickerComponent,
    ],
    declarations: [UptimesOverviewComponent, UptimeShowComponent, IncidentListComponent],
    exports: [UptimesOverviewComponent, UptimeShowComponent, IncidentListComponent],
})
export class UpgradeUptimesModule {}
